import { createFileRoute } from '@tanstack/react-router'
import { MachineCalendarEditor } from './-MachineCalendarEditor'

export const Route = createFileRoute('/production/machine-calendar/$machineId')({
  component: MachineCalendarDetailPage,
})

function MachineCalendarDetailPage() {
  const { machineId } = Route.useParams()
  return <MachineCalendarEditor machineId={machineId} />
}
